interface _Config {
    replayEnabled: boolean;
    errorTrackingEnabled: boolean;
    usageMetricsEnabled: boolean;
}

/** Ensures that error tracking has to be turned on when replay has been turned on */
export type ObservabilityAndMonitoringConfig =
    | (_Config & { replayEnabled: true; errorTrackingEnabled: true })
    | (_Config & { replayEnabled: false; errorTrackingEnabled: false })
    | (_Config & { replayEnabled: false; errorTrackingEnabled: true });
